export enum BadgeColorsEnum {
  Gray = 'bg-gray-300 text-gray-800',
  Red = 'bg-red-100 text-red-800',
  Blue = 'bg-blue-100 text-blue-800',
  LightBlue = 'bg-light-blue-200 text-color-primary',
  Green = 'bg-green-100 text-green-800',
  Yellow = 'bg-yellow-100 text-yellow-800',
  Purple = 'bg-purple-100 text-purple-800',
  Pink = 'bg-[#FCE7F5] text-[#D9428C]',
  Default = 'bg-gray-100 text-gray-800',
}
